import { FormHorizontal } from '~/components/form/layout';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';
import { format_money } from '~/components/Money';
import TwtNucleusJob from '~/tenants/twt/performable/nucleus/TwtNucleusJob';

export default function TwtNucleusGuidedForm() {
  return (
    <FormHorizontal label="Live Virtual Tours">
      <ZodFieldSelect
        options={[
          { label: `25 Live Virtual Tours: ${format_money(TwtNucleusJob.guided(25))}`, value: '25' },
          { label: `50 Live Virtual Tours: ${format_money(TwtNucleusJob.guided(50))}`, value: '50' },
          { label: `100 Live Virtual Tours: ${format_money(TwtNucleusJob.guided(100))}`, value: '100' },
        ]}
        name="guided"
      />
    </FormHorizontal>
  );
}
